import { ReactElement } from "react";
import {
  FileOutlined,
  FileUnknownOutlined,
  PictureOutlined,
  CodeOutlined,
  CloudOutlined,
  BgColorsOutlined,
} from "@ant-design/icons";
import LayoutCard from "../../../shared-ui-components/LayoutCard";
import InnerCard from "../../../shared-ui-components/InnerCard";
import { HtmlElementsSummary } from "../../../models/url-analysis-data-structures";
import "./UrlPageMetadataCard.scss";

interface UrlPageMetadataCardProps {
  htmlSummary: HtmlElementsSummary | null;
}

export default function UrlPageMetadataCard({
  htmlSummary,
}: UrlPageMetadataCardProps): ReactElement | null {
  if (!htmlSummary) return null;

  return (
    <LayoutCard>
      {{
        content: (
          <>
            <div className="layout-card-header-text flex-row-with-vertical-alignment">
              <FileUnknownOutlined className="icon-with-background" />
              Page Information
            </div>
            <div className="top-summary-card-inner-cards-wrapper">
              <InnerCard className="file-information-inner-card page-info-title">
                {{
                  header: {
                    icon: <FileOutlined />,
                    isIconHighlighted: true,
                    text: "Title",
                  },
                  content: htmlSummary.Title || "-",
                }}
              </InnerCard>
              {htmlSummary.Images && (
                <InnerCard className="file-information-inner-card page-info-images">
                  {{
                    header: {
                      icon: <PictureOutlined />,
                      isIconHighlighted: true,
                      text: "Images",
                    },
                    content: (
                      <div className="html-summary-field-content">
                        <div>Total: {htmlSummary.Images.Total}</div>
                        <div>Remote: {htmlSummary.Images.Remote}</div>
                        <div>Clickable: {htmlSummary.Images.Clickable}</div>
                      </div>
                    ),
                  }}
                </InnerCard>
              )}
              {htmlSummary.Scripts && (
                <InnerCard className="file-information-inner-card page-info-scripts">
                  {{
                    header: {
                      icon: <CodeOutlined />,
                      isIconHighlighted: true,
                      text: "Scripts",
                    },
                    content: (
                      <div className="html-summary-field-content">
                        <div>Total: {htmlSummary.Scripts.Total}</div>
                        <div>Remote: {htmlSummary.Scripts.Remote}</div>
                      </div>
                    ),
                  }}
                </InnerCard>
              )}
              {htmlSummary.ExternalResourceLinks && (
                <InnerCard className="file-information-inner-card page-info-external-resource-links">
                  {{
                    header: {
                      icon: <CloudOutlined />,
                      isIconHighlighted: true,
                      text: "External Resource Links",
                    },
                    content: (
                      <div className="html-summary-field-content">
                        <div>
                          Total: {htmlSummary.ExternalResourceLinks.Total}
                        </div>
                        <div>
                          Remote: {htmlSummary.ExternalResourceLinks.Remote}
                        </div>
                      </div>
                    ),
                  }}
                </InnerCard>
              )}
              {htmlSummary.Svg && (
                <InnerCard className="file-information-inner-card page-info-svg">
                  {{
                    header: {
                      icon: <BgColorsOutlined />,
                      isIconHighlighted: true,
                      text: "SVG",
                    },
                    content: <div>Total: {htmlSummary.Svg.Total}</div>,
                  }}
                </InnerCard>
              )}
            </div>
          </>
        ),
      }}
    </LayoutCard>
  );
}
